import React from "react";
import "../BlockChain/Blockchain.css";
import "./WebDevelopment.css";
import { NavLink } from "react-router-dom";
import {
  FiArrowRight,
  FiDatabase,
  FiShoppingCart,
  FiServer,
  FiGlobe,
  FiCode,
  FiHexagon,
} from "react-icons/fi";

const WebDevelopment = () => {
  return (
    <div className="sub-service-page webdev-page">
      <div className="page-bg-engine">
        <div className="theme-orb orb-primary"></div>
        <div className="theme-orb orb-secondary"></div>
      </div>
      {/* --- Section 1: Sovereign Hero --- */}
      <section className="sub-hero">
        <div className="v2-container">
          <div className="sub-hero-content">
            <div className="v3-badge">Enterprise Systems</div>
            <h1 className="title-reveal">
              Architecting the <span className="blue-glow">Modern</span> Web
            </h1>
            <p className="v3-hero-p-centered">
              Modernizing corporate infrastructure with high-availability
              cloud-native architectures. We build beautiful, functional, and
              secure digital storefronts for global scale.
            </p>
          </div>
        </div>
      </section>

      {/* --- Section 2: Intro --- */}
      <section className="sub-content-section">
        <div className="v2-container">
          <div className="content-layout-left">
            <h2 className="v3-title">
              The Digital <span className="blue-glow">Frontier</span>
            </h2>
            <p className="v3-p-text">
              Experience the difference with advanced and innovative web
              development services. From intuitive UI to seamless e-commerce
              integrations, our engineering is designed to stand out.
            </p>

            <div className="tech-stack-strip">
              {[
                "web1.png",
                "web2.png",
                "web3.png",
                "web4.png",
                "web5.png",
                "web6.png",
                "web7.png",
              ].map((img, i) => (
                <img src={`/${img}`} alt={`Tech ${i}`} key={i} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 3: Platform Grid --- */}
      <section className="sub-features-section">
        <div className="v2-container">
          <div className="v3-section-head left">
            <h2 className="v3-title">
              Our <span className="blue-glow">Platform</span> Mastery
            </h2>
          </div>

          <div className="feature-grid-sub">
            {[
              {
                icon: <FiGlobe />,
                title: "WordPress",
                desc: "Customized, scalable CMS solutions optimized for speed and SEO.",
              },
              {
                icon: <FiShoppingCart />,
                title: "Shopify",
                desc: "High-performance eCommerce stores with complex integration capabilities.",
              },
              {
                icon: <FiCode />,
                title: "React Ecosystem",
                desc: "Exceptional user interfaces for custom, high-traffic data-driven apps.",
              },
              {
                icon: <FiDatabase />,
                title: "Drupal",
                desc: "Enterprise-grade content management for complex data architectures.",
              },
              {
                icon: <FiServer />,
                title: "PHP Laravel",
                desc: "Secure, flexible backend engineering for robust corporate portals.",
              },
              {
                icon: <FiHexagon />,
                title: "MERN Stack",
                desc: "Modern full-stack JavaScript for high-velocity startup scaling.",
              },
            ].map((item, idx) => (
              <div className="feature-card-sub" key={idx}>
                <div className="f-icon-box">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- Section 4: Solution Deep Dives --- */}
      <section className="sub-platforms">
        <div className="v2-container">
          <div className="platform-row">
            <div className="platform-text">
              <h2 className="v3-title">
                Full-Stack <span className="blue-glow">Excellence</span>
              </h2>
              <p className="v3-p-text">
                We provide comprehensive services from front-end to back-end,
                utilizing React.js, Angular, Python, and .NET to meet complex
                business needs.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Initialize Build <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <img src="/full.png" alt="Full Stack" />
            </div>
          </div>

          <div className="platform-row reverse">
            <div className="platform-text">
              <h2 className="v3-title">
                E-commerce <span className="blue-glow">Ecosystems</span>
              </h2>
              <p className="v3-p-text">
                Effective digital retail solutions featuring secure payment
                processing, custom product filtering, and scalable warehouse
                logic.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Technical Proposal <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <img src="/ecom.png" alt="Ecom" />
            </div>
          </div>

          <div className="platform-row">
            <div className="platform-text">
              <h2 className="v3-title">
                Server-Side <span className="blue-glow">Architecture</span>
              </h2>
              <p className="v3-p-text">
                Our experts design bespoke databases (MySQL, PostgreSQL) and
                high-availability APIs that ensure your infrastructure is always
                operational.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Cloud Strategy <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <img src="/back.webp" alt="Back End" />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 5: Universal CTA --- */}
      <section className="v3-final-cta">
        <div className="v2-container">
          <div className="v3-cta-card">
            <div className="v3-cta-content">
              <h2 className="v3-cta-title">
                Ready to <br />
                <span className="grad-blue">Transform Your Business?</span>
              </h2>
              <NavLink to="/contactus" className="v3-main-btn">
                <span>Book a Call</span>
                <div className="btn-icon-box">
                  <FiArrowRight />
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WebDevelopment;
